import {IStateService} from 'angular-ui-router';
import VersicherungRS from '../../../core/service/versicherungRS.rest';
import VersicherungsbeitragModelManager from '../../../core/service/VersicherungsbeitragModelManager';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {getTSSchadenArtValues, schadenartPrefix, TSSchadenArt} from '../../../models/enums/TSSchadenArt';
import {isStatusInBearbeitung} from '../../../models/enums/TSVersicherungsbeitragStatus';
import TSVersicherung from '../../../models/TSVersicherung';
import TSVersicherungsbeitrag from '../../../models/TSVersicherungsbeitrag';
import DVBernUtil from '../../../utils/DVBernUtil';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./versicherungsbeitragSchadenView.scss');
let template = require('./versicherungsbeitragSchadenView.html');

export class VersicherungsbeitragSchadenViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = VersicherungsbeitragSchadenViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        versicherungsbeitrag: '<'
    };
}

export class VersicherungsbeitragSchadenViewController extends AbstractGesuchViewController<TSVersicherungsbeitrag> {

    versicherungsbeitrag: TSVersicherungsbeitrag;
    form: IFormController;
    readonly: boolean;
    possibleVersicherungen: Array<TSVersicherung> = [];
    doctype: TSDocumentType = TSDocumentType.VERSICHERUNGSBEITRAG_DOC;

    static $inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log', '$state', 'VersicherungsbeitragModelManager', 'VersicherungRS'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private  $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private versicherungsbeitragModelManager: VersicherungsbeitragModelManager,
                private versicherungRS: VersicherungRS) {
        super($scope);
    }

    $onInit() {
        super.$onInit();
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag();
            // this.versicherungsbeitrag.versicherungsbeitragDatenFS = new TSVersicherungsbeitragDaten();
            // this.versicherungsbeitrag.versicherungsbeitragStundenDaten = [];
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        } else {
            this.initialModel = this.versicherungsbeitrag;
            this.model = angular.copy(this.versicherungsbeitrag);
        }

        this.readonly = !isStatusInBearbeitung(this.model.status);

        this.loadAvailableAnlaufstellen();
    }

    public loadAvailableAnlaufstellen(): void {

        this.versicherungRS.findActiveVersicherungen().then((response: Array<TSVersicherung>) => {
            this.possibleVersicherungen = this.possibleVersicherungen.concat(response);
        });
    }

    public saveVersicherungsbeitrag() {
        if (this.isModelValid() && this.model) {
            this.versicherungsbeitragModelManager.saveVersicherungsbeitrag(this.getModel()).then((result: TSVersicherungsbeitrag) => {
                this.$state.go('versicherungbeitragversicherter', {versicherungsbeitragId: result.id})
            });
        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelVersicherungsbeitrag() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('versicherungsbeitraege')

    }

    public getViewTitle(): string {
        return this.dvBernUtil.getVersicherungsbeitragViewTitle(this.model);
    }

    private getTSSchadenArtValues(): Array<TSSchadenArt> {
        return getTSSchadenArtValues();
    }

    public getSchadenArtPrefix(): string {
        return schadenartPrefix();
    }

    public translateSchadenArt(art: TSSchadenArt): string {
        let prefix = this.getSchadenArtPrefix();
        return this.$translate.instant(prefix + TSSchadenArt[art])
    }

    public showAndere() {
        return this.getModel().schadenArt === TSSchadenArt.ANDERE;
    }

}



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/component/versicherungsbeitragSchadenView/versicherungsbeitragSchadenView.ts